import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
const WithoutAuthRoute = () => {
    const token = useSelector(state => state?.userData?.access_token)
    const user = useSelector(state => state?.userData?.user)

    if (token ) {
        return <Navigate to="/dashboard" />;
    }

    // if (token ) {
    //     return <Navigate to="/basic-detail" />;
    // }

    // If logged in but not approved → go to application status
    // if (token && user?.approve_status !== 'approved') {
    //     return <Navigate to="/application-status" />;
    // }

    return <Outlet />;

    // return (
    //     <>
    //         {!token ? <Outlet />  : <Navigate to='/dashboard' />}
    //     </>
    // )
}
export default WithoutAuthRoute;